import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import "./chartApplication.css";
import Chart from "react-apexcharts";
import { useTranslation } from "react-i18next";
import { registerLocale } from "react-datepicker";
import { fr, enUS } from "date-fns/locale";
import { useDispatch, useSelector } from "react-redux";
import { fetchDataChart } from "../../../../../redux/chart/chartAction";
import moment from "moment";
import Skeleton from "react-loading-skeleton";
import { Download } from "react-iconly";
import ModalExtraction from "./ModalExtraction";

let lng = window.localStorage.getItem("i18nextLng");

registerLocale(lng === "en" ? "en" : "fr", lng === "en" ? enUS : fr);

var ChartApplication = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  let data = useSelector((state) => state?.dataChart);
  const [startDate, setStartDate] = useState(new Date());
  useEffect(() => {
    dispatch(fetchDataChart(moment(startDate).format("DD-MM-YYYY")));
  }, [dispatch, startDate]);
  const series = [
    {
      name: t("nbr_connexion"),
      data: data?.isLoading ? [0, 0, 0, 0, 0, 0, 0] : data?.data,
    },
  ];
  const options = {
    chart: {
      height: 350,
      background: "#FFFFFF",
      type: "line",
      zoom: {
        enabled: true,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      width: 2,
      curve: "smooth",
    },
    tooltip: {
      enabled: true,
      enabledOnSeries: undefined,
      shared: true,
      followCursor: false,
      intersect: false,
      inverseOrder: false,
      custom: undefined,
      fillSeriesColor: false,
      theme: false,
      style: {
        fontSize: "12px",
        fontFamily: undefined,
      },
      x: {
        show: true,
        formatter: undefined,
      },
      y: {
        formatter: undefined,
        title: {
          formatter: (seriesName) => seriesName,
        },
      },
      z: {
        formatter: undefined,
        title: "Size: 20px",
      },
      marker: {
        show: true,
      },
    },
    colors: ["#003DA5"],

    // fill: {
    //   colors: ["#01223a09 96.74%)"],
    // },
    fill: {
      colors: ["rgb(0,61,165, 0) 96.74%"],
    },

    grid: {
      show: true,

      xaxis: {
        lines: {
          show: true,
        },
      },
      yaxis: {
        lines: {
          show: true,
        },
      },
    },
    xaxis: {
      categories: [
        t("monday"),
        t("tuesday"),
        t("wednesday"),
        t("thursday"),
        t("friday"),
        t("saturday"),
        t("sunday"),
      ],
    },

    yaxis: {
      show: true,
    },

    legend: {
      show: false,
    },
  };

  const handleDateChange = (date) => {
    setStartDate(date);
  };

  return (
    <div className="component-chart-application">
      <div className="d-sm-flex align-items-center mb-5 justify-content-between">
        <h4 className="title mb-sm-0 mb-3">{t("nbr_connexion")}</h4>

        <div className="d-flex" style={{ gap: "1rem" }}>
          <div className="">
            <button
              className="btn btn-download-document"
              style={{ width: "max-content", borderRadius: "100px" }}
              data-toggle="modal"
              data-target="#extractionModal"
            >
              <Download set="bold" primaryColor="#003DA5" />
              <span className="pl-2">{"Statistiques du mois"}</span>
            </button>
          </div>

          <DatePicker
            dateFormat={"dd/MM/yyyy"}
            className="form-control chart-date"
            selected={startDate}
            onChange={handleDateChange}
            locale={lng === "en" ? "en" : "fr"}
            showWeekNumbers
          />
        </div>
      </div>

      {data?.isLoading ? (
        <Skeleton height={400} />
      ) : (
        <Chart
          className="chart-dashboard-marketplace"
          options={options}
          series={series}
          data="Candidature"
          type="area"
          width="100%"
          height="400"
        />
      )}
      <ModalExtraction />
    </div>
  );
};

export default ChartApplication;
